module.exports = __webpack_public_path__ + "img/icon3.a35c63fe.png";